module.exports = __webpack_public_path__ + "img/imgs.4d159e65.png";